import React from "react";

const SelectController = ({ label, options, value, onChange, name }) => {
  return (
    <div className="flex flex-col w-40 max-sm:w-28">
      <label className="mb-1 text-white max-md:text-gray-500 max-md:text-[12px] max-md:mb-0 text-sm">{label}</label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        className="p-2 bg-white border border-gray-300 rounded-lg focus:outline-none"
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectController;
